import React from "react";
import { motion } from "framer-motion";
import ResumeCard from "./ResumeCard";

const Education = () => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1, transition: { duration: 0.5 } }}
      className="w-full flex flex-col lgl:flex-row gap-10 lgl:gap-20"
    >
      {/* Education Section */}
      <div>
        <div className="py-6 lgl:py-12 font-titleFont flex flex-col gap-4">
          <p className="text-sm text-designColor tracking-[4px]">2023 - 2027</p>
          <h2 className="text-3xl md:text-4xl font-bold">Education</h2>
        </div>
        <div className="mt-6 lgl:mt-14 w-full h-auto border-l-[6px] border-l-black border-opacity-30 flex flex-col gap-10">
          <ResumeCard
            title="Bachelor of Technology - Computer Science & Engineering"
            subTitle="IILM University, Greater Noida"
            result="CGPA: 8.5/10 (Expected 2027)"
            des="Specialized in full-stack development, application security, and cryptography. Coursework includes Computer Networks, Operating Systems, Web Security, DBMS, and Linux Systems."
          />
          <ResumeCard
            title="Google Cybersecurity Professional Certificate"
            subTitle="Online - Coursera"
            result="2024 - 2025"
            des="Comprehensive training in cybersecurity fundamentals, threat models, secure network design, and incident response strategies."
          />
          <ResumeCard
            title="Ethical Hacking Certification"
            subTitle="Infosys Springboard"
            result="2024"
            des="Hands-on penetration testing training with tools like Nmap, Burp Suite, and Wireshark. Covered vulnerability exploitation and exploitation techniques."
          />
        </div>
      </div>

      {/* Job Experience Section */}
      <div>
        <div className="py-6 lgl:py-12 font-titleFont flex flex-col gap-4">
          <p className="text-sm text-designColor tracking-[4px]">2022 - Present</p>
          <h2 className="text-3xl md:text-4xl font-bold">Job Experience</h2>
        </div>
        <div className="mt-6 lgl:mt-14 w-full h-[1000px] border-l-[6px] border-l-black border-opacity-30 flex flex-col gap-10">
          <ResumeCard
            title="Founder"
            subTitle="Taxify (2023 - Present)"
            result="Gurugram"
            des="Founded Taxify, a platform focused on simplifying the tax filing process using AI-driven models for accurate tax calculations and seamless filing experiences."
          />
          <ResumeCard
            title="WordPress Developer Intern"
            subTitle="Digital Dose (July 2023 - August 2023)"
            result="Remote"
            des="Completed a 3-month internship as a WordPress Developer. Gained hands-on experience in building and maintaining WordPress websites."
          />
          <ResumeCard
            title="GDG On-Campus Organizer"
            subTitle="Google Developer Group, IILM University (2024 - Present)"
            result="Gurugram"
            des="Organizing tech events, workshops, and fostering community engagement at IILM University as an active GDG on-campus organizer."
          />
        </div>
      </div>
    </motion.div>
  );
};
export default Education;
